import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import "../../styles/righttab.css"

function PPMultiMatchInput(props) {
    const [locations, setLocations] = useState()
    const [t] = useTranslation()

    useEffect(() => {
        setLocations(props.selectedProductCell?.url.split("|"))
    }, [props])

    function newURL() {
        const newLocations = [...locations, ""]
        setLocations(newLocations)
        props.selectedProductCell.url = newLocations.join("|")
    }

    function removeURL(indexToRemove) {
        if (indexToRemove == 0) {
            return
        }
        const newLocations = locations.filter((_, i) => i !== indexToRemove)
        setLocations(newLocations)
        props.selectedProductCell.url = newLocations.join("|")
    }

    function handleURLChange(e, idx) {
        const newLocations = [...locations]
        newLocations[idx] = e.target.value
        setLocations(newLocations)
        props.selectedProductCell.url = newLocations.join("|")
    }

    return (
        <div id="multimatch-input-fields">
            {locations?.map((url, idx) => (
                <div key={idx} className="input-group mb-2">
                    <input
                        type="input"
                        className="form-control"
                        id={"inputURL" + idx}
                        placeholder="https://example.url/product/12"
                        value={url}
                        onChange={(e) => handleURLChange(e, idx)}
                    />
                    <a target="_blank" rel="noopener noreferrer" href={url} className="mb-2">
                        <i className={"fas fa-external-link-alt righttab-icon match-link"} />
                    </a>
                    {idx > 0 && (
                        <button type="button" className="btn btn-danger" onClick={() => removeURL(idx)}>
                            {t("single.delete")}
                        </button>
                    )}
                </div>
            ))}
            <button type="button" onClick={() => newURL()} className="btn btn-primary">
                {t("single.add")}
            </button>
        </div>
    )
}

export default PPMultiMatchInput
